export default __webpack_public_path__ + "static/media/profile-photo-1000.207abd09.png";